export default __webpack_public_path__ + "static/media/Other.b0229f65.svg";